import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { translate } from '@fiverr-private/i18n-react';
import { HEADER_NAV_SOURCE } from '../../../../constants';
import Link from '../../../Links/Link';

const SellerAchievementsLink = () => (
    <Link
        href={pathfinder('levels_page', null, { query: { source: HEADER_NAV_SOURCE } })}
        rel="noopener noreferrer"
        className="nav-link"
    >
        {translate('header.seller_overview')}
    </Link>
);

export default SellerAchievementsLink;
